// Learning data with examples and image references
export const learningData = {
  alphabet: {
    'A': { word: 'Apple', emoji: 'apple', description: 'Red fruit' },
    'B': { word: 'Ball', emoji: 'ball', description: 'Round toy' },
    'C': { word: 'Cat', emoji: 'cat', description: 'Pet animal' },
    'D': { word: 'Dog', emoji: 'dog', description: 'Friendly pet' },
    'E': { word: 'Elephant', emoji: 'elephant', description: 'Big animal' },
    'F': { word: 'Fish', emoji: 'fish', description: 'Water animal' },
    'G': { word: 'Grapes', emoji: 'grapes', description: 'Sweet fruit' },
    'H': { word: 'House', emoji: 'house', description: 'Place to live' },
    'I': { word: 'Ice Cream', emoji: 'icecream', description: 'Cold dessert' },
    'J': { word: 'Juice', emoji: 'juice', description: 'Healthy drink' },
    'K': { word: 'Kite', emoji: 'kite', description: 'Flying toy' },
    'L': { word: 'Lion', emoji: 'lion', description: 'Wild animal' },
    'M': { word: 'Moon', emoji: 'moon', description: 'Night object' },
    'N': { word: 'Nest', emoji: 'nest', description: 'Bird home' },
    'O': { word: 'Orange', emoji: 'orange', description: 'Citrus fruit' },
    'P': { word: 'Pencil', emoji: 'pencil', description: 'Writing tool' },
    'Q': { word: 'Queen', emoji: 'queen', description: 'Royal person' },
    'R': { word: 'Rose', emoji: 'rose', description: 'Beautiful flower' },
    'S': { word: 'Sun', emoji: 'sun', description: 'Bright star' },
    'T': { word: 'Tree', emoji: 'tree', description: 'Tall plant' },
    'U': { word: 'Umbrella', emoji: 'umbrella', description: 'Rain protection' },
    'V': { word: 'Van', emoji: 'van', description: 'Vehicle' },
    'W': { word: 'Water', emoji: 'water', description: 'Clear liquid' },
    'X': { word: 'Xylophone', emoji: 'xylophone', description: 'Musical instrument' },
    'Y': { word: 'Yacht', emoji: 'yacht', description: 'Luxury boat' },
    'Z': { word: 'Zebra', emoji: 'zebra', description: 'Striped animal' }
  },
  numbers: {
    '0': { word: 'Zero', emoji: 'zero', description: 'No objects' },
    '1': { word: 'One', emoji: 'one', description: 'Single object' },
    '2': { word: 'Two', emoji: 'two', description: 'Pair of objects' },
    '3': { word: 'Three', emoji: 'three', description: 'Triangle' },
    '4': { word: 'Four', emoji: 'four', description: 'Square sides' },
    '5': { word: 'Five', emoji: 'five', description: 'Fingers on hand' },
    '6': { word: 'Six', emoji: 'six', description: 'Dice number' },
    '7': { word: 'Seven', emoji: 'seven', description: 'Days in week' },
    '8': { word: 'Eight', emoji: 'eight', description: 'Spider legs' },
    '9': { word: 'Nine', emoji: 'nine', description: 'Lucky number' }
  },
  hindi: {
    '': { word: ' ', emoji: ' ', description: 'First vowel' },
    '': { word: ' ', emoji: ' ', description: 'Long vowel' },
    '': { word: ' ', emoji: ' ', description: 'Short i' },
    '': { word: ' ', emoji: ' ', description: 'Long i' },
    '': { word: ' ', emoji: ' ', description: 'Short u' },
    '': { word: ' ', emoji: ' ', description: 'Long u' },
    '': { word: ' ', emoji: ' ', description: 'R sound' },
    '': { word: ' ', emoji: ' ', description: 'Short e' },
    '': { word: ' ', emoji: ' ', description: 'Long e' },
    '': { word: ' ', emoji: ' ', description: 'Short o' },
    '': { word: ' ', emoji: ' ', description: 'Long o' },
    '': { word: ' ', emoji: ' ', description: 'Ka', description: 'First consonant' },
    '': { word: ' ', emoji: ' ', description: 'Kha' },
    '': { word: ' ', emoji: ' ', description: 'Ga' },
    '': { word: ' ', emoji: ' ', description: 'Gha' },
    '': { word: ' ', emoji: ' ', description: 'Nga' },
    '': { word: ' ', emoji: ' ', description: 'Cha' },
    '': { word: ' ', emoji: ' ', description: 'Chha' },
    '': { word: ' ', emoji: ' ', description: 'Ja' },
    '': { word: ' ', emoji: ' ', description: 'Jha' },
    '': { word: ' ', emoji: ' ', description: 'Nya' },
    '': { word: ' ', emoji: ' ', description: 'Ta' },
    '': { word: ' ', emoji: ' ', description: 'Tha' },
    '': { word: ' ', emoji: ' ', description: 'Da' },
    '': { word: ' ', emoji: ' ', description: 'Dha' },
    '': { word: ' ', emoji: ' ', description: 'Na' },
    '': { word: ' ', emoji: ' ', description: 'Ta' },
    '': { word: ' ', emoji: ' ', description: 'Tha' },
    '': { word: ' ', emoji: ' ', description: 'Da' },
    '': { word: ' ', emoji: ' ', description: 'Dha' },
    '': { word: ' ', emoji: ' ', description: 'Na' },
    '': { word: ' ', emoji: ' ', description: 'Pa' },
    '': { word: ' ', emoji: ' ', description: 'Pha' },
    '': { word: ' ', emoji: ' ', description: 'Ba' },
    '': { word: ' ', emoji: ' ', description: 'Bha' },
    '': { word: ' ', emoji: ' ', description: 'Ma' },
    '': { word: ' ', emoji: ' ', description: 'Ya' },
    '': { word: ' ', emoji: ' ', description: 'Ra' },
    '': { word: ' ', emoji: ' ', description: 'La' },
    '': { word: ' ', emoji: ' ', description: 'Va' },
    '': { word: ' ', emoji: ' ', description: 'Sha' },
    '': { word: ' ', emoji: ' ', description: 'Shha' },
    '': { word: ' ', emoji: ' ', description: 'Sa' },
    '': { word: ' ', emoji: ' ', description: 'Ha' }
  }
};

// Helper function to get learning data for an item
export const getLearningData = (type, item) => {
  return learningData[type]?.[item] || { word: item, emoji: 'default', description: 'Practice this character' };
};
